import * as React from 'react';

import type { CmlContent } from '@coursera-web/cml';
import { CML, CMLUtils } from '@coursera-web/cml';

import CollectionDescriptionFragment from 'bundles/enterprise-collections/queries/CollectionDescriptionFragment';
import withFragments from 'bundles/graphql/components/withFragments';

export type Description = {
  cml?: {
    value: string;
    dtdId: string;
  };
};

type Props = {
  collection: {
    description: Description;
  };
};

export function CollectionDescription({ collection: { description } }: Props) {
  try {
    if (description.cml?.value && description.cml?.dtdId) {
      const cml: CmlContent = CMLUtils.create(description.cml.value, description.cml.dtdId);
      const isDescriptionPresent = CMLUtils.getLength(cml) > 0;

      return isDescriptionPresent ? <CML cml={cml} /> : null;
    }
    return null;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export default withFragments({
  collection: CollectionDescriptionFragment,
})(CollectionDescription);
